module.exports = __webpack_public_path__ + "img/nav2-active.b6053691.png";